import {authHeader} from '../../helpers/index';
import {baseUrl} from '../constants';
import {handleResponse} from './responseHandler';

export const workorderStatusService = {};

const apiUrl = baseUrl;

workorderStatusService.createWorkorderStatus = (workorder_status) => {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('POST'),
        body: JSON.stringify({workorder_status})
    };

    return fetch(`${apiUrl}/workorder_status`, requestOptions).then(handleResponse);
};

workorderStatusService.getAll = () => {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('GET')
    };

    return fetch(`${apiUrl}/workorder_statuses`, requestOptions).then(handleResponse)
};

workorderStatusService.getStatus = (id) => {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('GET')
    };

    return fetch(`${apiUrl}/workorder_status/` + id, requestOptions).then(handleResponse);
};
